import {motion} from 'motion/react';
import PropTypes from 'prop-types';

import {Button} from '@src/components/ui/button';
import { handleInPageSmoothScroll } from '@src/hooks/useSmoothScroll.jsx';

import BOSSSProductSection from './BOSSSProductSection.jsx';
import GradientMeshBackground from './GradientMeshBackground.jsx';
import ParticleNetworkBackground from './ParticleNetworkBackground.jsx';

function FuturisticCTAButtons({onNavigateToTop}) {

  return (
    <motion.div
      animate={{opacity: 1, y: 0}}
      initial={{opacity: 0, y: 30}}
      className="flex flex-col sm:flex-row gap-6 sm:gap-8 justify-center items-center px-4"
      transition={{
        duration: 0.8,
        delay: 3.2,
        ease: 'easeOut',
      }}
    >
      {/* Primary Button */}
      <motion.div whileTap={{scale: 0.95}} whileHover={{scale: 1.05}}>
        <Button
          className="relative w-full sm:w-auto px-10 sm:px-16 py-4 sm:py-5 text-base sm:text-lg font-semibold border-0 overflow-hidden rounded-2xl group"
          style={{
            background: 'linear-gradient(135deg, #1e638d 0%, #2563eb 100%)',
            color: 'white',
            fontFamily: '"Inter", system-ui, sans-serif',
            boxShadow:
              '0 10px 40px rgba(30, 99, 141, 0.4), 0 4px 15px rgba(0, 0, 0, 0.1)',
            transition: 'all 0.4s ease',
          }}
          onClick={() => onNavigateToTop('/demo')}
        >
          <span className="relative z-10">Schedule a Demo</span>
        </Button>
      </motion.div>

      {/* Secondary Button */}
      <motion.div whileTap={{scale: 0.97}} whileHover={{scale: 1.03}}>
        <Button
          variant="outline"
          className="relative w-full sm:w-auto px-10 sm:px-16 py-4 sm:py-5 text-base sm:text-lg font-semibold bg-white/80 backdrop-blur-sm overflow-hidden rounded-2xl group"
          style={{
            borderWidth: '2px',
            borderColor: '#1e638d',
            color: '#1e638d',
            fontFamily: '"Inter", system-ui, sans-serif',
            boxShadow:
              '0 8px 30px rgba(30, 99, 141, 0.15), 0 4px 15px rgba(255, 255, 255, 0.1)',
            transition: 'all 0.4s ease',
          }}
          onClick={(e) => handleInPageSmoothScroll(e, '#platform-overview')}
        >
          <span className="relative z-10">Learn More</span>
        </Button>
      </motion.div>
    </motion.div>
  );
}

FuturisticCTAButtons.propTypes = {
  onNavigate: PropTypes.func.isRequired, // or PropTypes.func if optional
};

export function HeroSection({onNavigate, onNavigateToTop}) {
  return (
    <section className="relative bg-gradient-to-br from-white via-slate-50/30 to-white overflow-hidden">
      <div className="absolute inset-0 z-0 pointer-events-none">
        {/* Gradient mesh at the back */}
        <GradientMeshBackground />
        {/* Particle network layered on top */}
        <ParticleNetworkBackground />
      </div>

      {/* Gradient overlay to fade bottom */}
      <div
        className="absolute inset-0 bg-gradient-to-b from-transparent via-white/40 to-white pointer-events-none z-5"
      />

      <div
        className="relative w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-8 sm:pt-12 pb-4 sm:pb-6 z-10 flex flex-col"
      >
        <div className="text-center">
          {/* <CompanyBranding /> */}
          <BOSSSProductSection />
          <FuturisticCTAButtons onNavigate={onNavigate} onNavigateToTop={onNavigateToTop} />
        </div>
      </div>
    </section>
  );
}


HeroSection.propTypes = {
  onNavigate: PropTypes.func.isRequired,
};

export default HeroSection;
